import React, { useState } from "react";
import { Tooltip } from "antd";

function HeadOffice() {
    const [search, setSearch] = useState("");

    const employees = [
        {
            name: "Thiru. A. JOHN LOUIS I.A.S",
            designation: "Managing Director",
            section: "Administration",
            landline: "044-22302300",
            email: "md.tnwc@tn.gov.in",
        },
        {
            name: "Thiru. C.SURESH",
            designation: "General Manager",
            section: "Administration",
            landline: "6380605275",
            email: "gm.tnwc@tn.gov.in",

        },
        {
            name: "Thiru. A.ARUL KUMAR",
            designation: "Financial Advisor & Chief Accounts Officer",
            section: "Finance",
            landline: "9488472467",
            email: "",

        },
        {
            name: "Thiru. M.BALU",
            designation: "Executive Engineer",
            section: "Construction",
            landline: "9080274058",
            email: "",

        },
        {
            name: "Thiru. P.SANKARANARAYANAN",
            designation: "Assistant Construction Engineer",
            section: "Construction",
            landline: "9442491798",
            email: "tnwcconstruction@gmail.com",

        },
        {
            name: "Thiru. G.RAJASINGH",
            designation: "Assistant General Manager",
            section: "Technical",
            landline: "9952521713",
            email: "tnwctech@gmail.com",

        },
        {
            name: "Thiru. R.VENKATESAN",
            designation: "Assistant General Manager",
            section: "Business",
            landline: "9940458706",
            email: "hthochennai@gmail.com",

        },
        {
            name: "Tmt. B.SUNDARI",
            designation: "Assistant General Manager",
            section: "Finance",
            landline: "7010149712",
            email: "tnwc.corp@gmail.com",

        },
        {
            name: "Thiru. M.VASANTHAN",
            designation: "Assistant General Manager",
            section: "Collection",
            landline: "9786227787",
            email: "collection.tnwc@gmail.com",

        },
        {
            name: "Thiru. V.SANKARANARAYANAN",
            designation: "Manager",
            section: "Admin",
            landline: "9840676111",
            email: "tnwcestt@gmail.com",

        },
        {
            name: "Tmt. D.SANGEETHA",
            designation: "Manager",
            section: "EDP & IA (i/c)",
            landline: "9629295700",
            email: "tnwcedp@gmail.com",

        },
        {
            name: "Thiru. N.PRABHU",
            designation: "Manager",
            section: "DESS",
            landline: "8940799369",
            email: "tnwc.dess@gmail.com",

        },
    ];

    const filteredEmployees = employees.filter((employee) =>
        `${employee.name} ${employee.designation} ${employee.section}`
            .toLowerCase()
            .includes(search.toLowerCase())
    );

    return (
        <div className="container py-4 py-md-5">

            {/* ================= HEADER ================= */}
            <div
                className="rounded-4 p-4 p-md-5 mb-4 text-white position-relative overflow-hidden"
                style={{
                    background:
                        "linear-gradient(135deg, #8b0000 0%, #c62828 55%, #e53935 100%)",
                }}
            >
                <div className="position-relative">
                    <div className="d-flex align-items-center gap-2 mb-2">
                        <span className="badge bg-white text-danger px-3 py-2">
                            HEAD OFFICE
                        </span>
                    </div>

                    <h2 className="fw-bold mb-2">
                        Head Office Directory
                    </h2>

                    <p className="mb-0 opacity-75">
                        Tamil Nadu Warehousing Corporation
                    </p>
                </div>

                {/* Decorative circles */}
                <div
                    className="position-absolute rounded-circle"
                    style={{
                        width: "180px",
                        height: "180px",
                        right: "-60px",
                        top: "-70px",
                        background: "rgba(255,255,255,0.08)",
                    }}
                />

                <div
                    className="position-absolute rounded-circle"
                    style={{
                        width: "120px",
                        height: "120px",
                        right: "100px",
                        bottom: "-80px",
                        background: "rgba(255,255,255,0.06)",
                    }}
                />
            </div>

            {/* ================= SEARCH ================= */}
            <div className="card border-0 shadow-sm rounded-4 mb-4">
                <div className="card-body p-3 p-md-4">
                    <div className="row align-items-center g-3">

                        <div className="col-md-8">
                            <div className="input-group">
                                <span className="input-group-text bg-light border-end-0">
                                    <i className="bi bi-search text-muted"></i>
                                </span>

                                <input
                                    type="text"
                                    className="form-control bg-light border-start-0"
                                    placeholder="Search by name, designation or section..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="col-md-4 text-md-end">
                            <span className="text-muted small">
                                Showing{" "}
                                <strong className="text-dark">
                                    {filteredEmployees.length}
                                </strong>{" "}
                                of{" "}
                                <strong className="text-dark">
                                    {employees.length}
                                </strong>{" "}
                                employees
                            </span>
                        </div>

                    </div>
                </div>
            </div>

            {/* ================= EMPLOYEE LIST ================= */}
            <div className="row g-3">

                {filteredEmployees.map((employee, index) => (
                    <div className="col-12" key={index}>

                        <div
                            className="bg-white rounded-4 shadow-sm p-3 p-md-4"
                            style={{
                                borderLeft: "4px solid #dc3545",
                                transition: "all 0.2s ease",
                            }}
                        >

                            <div className="row align-items-center g-3">

                                {/* NUMBER */}
                                <div className="col-auto">
                                    <div
                                        className="rounded-3 d-flex align-items-center justify-content-center fw-bold"
                                        style={{
                                            width: "48px",
                                            height: "48px",
                                            backgroundColor: "#fff0f0",
                                            color: "#c62828",
                                            fontSize: "16px",
                                        }}
                                    >
                                        {String(index + 1).padStart(2, "0")}
                                    </div>
                                </div>

                                {/* NAME */}
                                <div className="col-md-3">
                                    <small className="text-muted d-block mb-1">
                                        EMPLOYEE
                                    </small>

                                    <h6 className="fw-bold mb-0 text-dark">
                                        {employee.name}
                                    </h6>
                                </div>

                                {/* DESIGNATION */}
                                <div className="col-md-4">
                                    <small className="text-muted d-block mb-1">
                                        DESIGNATION
                                    </small>

                                    <span className="text-dark">
                                        {employee.designation}
                                    </span>
                                </div>

                                {/* SECTION */}
                                <div className="col-md-2">
                                    <small className="text-muted d-block mb-1">
                                        SECTION
                                    </small>

                                    <span
                                        className="badge rounded-pill px-3 py-2"
                                        style={{
                                            backgroundColor: "#f1f3f5",
                                            color: "#495057",
                                        }}
                                    >
                                        {employee.section}
                                    </span>
                                </div>

                                {/* PHONE */}
                                <div className="col-md-2">
                                    <small className="text-muted d-block mb-1">
                                        Contact
                                    </small>


                                    <div className="text-dark d-flex flex-column gap-2">

                                        {/* Phone */}
                                        <div>
                                            <i className="bi bi-telephone me-2 text-danger"></i>

                                            <a
                                                href={`tel:${employee?.landline?.replace(/[\s()-]/g, "")}`}
                                                className="text-danger text-decoration-none"
                                            >
                                                {employee?.landline}
                                            </a>
                                        </div>

                                        {/* Email */}
                                        {employee?.email && (
                                            <div className="d-flex align-items-center">
                                                <i className="bi bi-envelope me-2 text-danger flex-shrink-0"></i>

                                                <Tooltip title={employee.email}>
                                                    <a
                                                        href={`mailto:${employee.email}`}
                                                        className="link-danger text-decoration-none text-truncate"
                                                        style={{
                                                            maxWidth: "180px",
                                                            display: "block",
                                                        }}
                                                    >
                                                        {employee.email}
                                                    </a>
                                                </Tooltip>
                                            </div>
                                        )}

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                ))}

            </div>

            {/* ================= NO RESULT ================= */}
            {
                filteredEmployees.length === 0 && (
                    <div className="text-center py-5">
                        <div
                            className="rounded-circle bg-light d-inline-flex align-items-center justify-content-center mb-3"
                            style={{
                                width: "70px",
                                height: "70px",
                            }}
                        >
                            <i className="bi bi-person-x fs-3 text-muted"></i>
                        </div>

                        <h5 className="fw-bold">
                            No employees found
                        </h5>

                        <p className="text-muted mb-0">
                            Try searching with another name, designation or section.
                        </p>
                    </div>
                )
            }

        </div >
    );
};

export default HeadOffice;